import React from 'react';
import { Container, Row} from 'reactstrap';
import { subscribe } from 'react-contextual';
import MediaQuery from 'react-responsive';
import SquareCard from '../../cards/squareCard';
import RightArrow from '../../icons/rightArrowSmall';
import onClickHandle from '../onClickHandle';

class CausePanel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showAll: false,
		};
	}
	showAll = () => {
		this.setState({ showAll: true });
	}
	render() {
		const { heading, data } = this.props;
		return (
			<Container className="panel-padding">
				<Row>
					<h2>{heading}</h2>
				</Row>
				<MediaQuery minWidth={768}>
					<Row className="cause-panel-remove-margins">
						{data.map((item, index) => <SquareCard {...item} position={index} key={index} clickHandler={(e) => onClickHandle(e, 'cause-panel-click', { index, cause: item.heading }, item.link)} show />)}
					</Row>
				</MediaQuery>
				<MediaQuery maxWidth={768}>
					<Row className="cause-panel-remove-margins">
						{data.map((item, index) => <SquareCard {...item} position={index} key={index} clickHandler={(e) => onClickHandle(e, 'cause-panel-click', { index, cause: item.heading }, item.link)} show={this.state.showAll} />)}
					</Row>
					{!this.state.showAll ? <div className="text-right">
						<a
							onClick={this.showAll}
							style={{
								color: '#444444', textDecoration: 'none', fontSize: '0.875rem', cursor: 'pointer',
							}}
						>
							<span style={{
								paddingRight: '6px',
							}}
							>View All
							</span> <RightArrow />
						</a>
					</div>
						:
						null}
				</MediaQuery>

				<style jsx global>{`
					.cause-panel-remove-margins {
						margin-left: -10px !important;
						margin-right: -10px !important;
					}
				`}
				</style>
			</Container>
		);
	}
}

CausePanel.defaultProps = {
	heading: 'Causes We Support',
	data: [
		{
			heading: 'health',
			initialText: '50 programs',
			hoverText: '1230 supporters',
			image: '/static/images/home/causes-health.jpg',
			link: '#',
		},
		{
			heading: 'women',
			initialText: '20 programs',
			hoverText: '1230 supporters',
			image: '/static/images/home/causes-women.jpg',
			link: '#',
		},
		{
			heading: 'education',
			initialText: '10 programs',
			hoverText: '1230 supporters',
			image: '/static/images/home/causes-education.jpg',
			link: '#',
		},
		{
			heading: 'differently abled',
			initialText: '7 programs',
			hoverText: '1230 supporters',
			image: '/static/images/home/causes-differentlyabled.jpg',
			link: '#',
		},
		{
			heading: 'elderly',
			initialText: '30 programs',
			hoverText: '1230 supporters',
			image: '/static/images/home/causes-elderly.jpg',
			link: '#',
		},
	],
};

export default subscribe()(CausePanel);
